module.exports = __webpack_public_path__ + "img/shortDui.2573ed30.png";